import { useContext, useEffect, useState } from 'react';
import * as React from 'react';
import { ErrorContext } from '../../state';
import {
    SeasonsClient,
    GameType,
    PlayersClient,
    ISeasonWithPlayersDto,
    IPlayerAppearancesListDto,
    ISeasonsWithPlayersVm,
    IPlayerAppearancesListVm
} from '../../WorldDoomLeague';
import { Col, Row, Table } from 'reactstrap';
import { Link, NavLink } from 'react-router-dom';

const Players = () => {
    const error = useContext(ErrorContext);
    const [loading, setLoading] = useState<boolean>(false);
    const [season, setSeason] = useState<number>(null);
    const [gameType, setGameType] = useState<GameType>(GameType.All);
    const [seasonData, setSeasonData] = useState<ISeasonWithPlayersDto[]>([]);
    const [playerData, setPlayerData] = useState<IPlayerAppearancesListDto[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                let client = new PlayersClient();
                const response = await client.getPlayerAppearances(season, gameType)
                    .then(response => response.toJSON() as Promise<IPlayerAppearancesListVm>);
                const data = response.playerList;
                setPlayerData(data);
            } catch (e) {
                error.setError(JSON.parse(e.response));
            }
            setLoading(false);
        };

        fetchData();
    }, [gameType, season]);

    useEffect(() => {
        const fetchData = async () => {
        setLoading(true);
        try {
            let client = new SeasonsClient();
            const response = await client.getSeasonsWithPlayers(gameType)
                .then(response => response.toJSON() as Promise<ISeasonsWithPlayersVm>);
            const data = response.seasonList;
            if ((data.find(f => f.id == season) || null) === null) {
                setSeason(null);
            }
            setSeasonData(data);
        } catch (e) {
            error.setError(JSON.parse(e.response));
        }
        setLoading(false);
        };

        fetchData();
    }, [gameType]);

    const renderDemosTable = () => {
        var tableArray = null;
        if (!loading) {
            tableArray = (
                <React.Fragment>
                    <Row>
                        <Col>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Player Name</th>
                                        <th>Game Appearances</th>
                                        <th>Round Appearances</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {playerData.length > 0 && playerData.map((s, idx) => (
                                        <tr>
                                            <td><NavLink to={`/player/${s.playerId}`}>{s.playerName}</NavLink></td>
                                            <td>{s.gameAppearances}</td>
                                            <td>{s.roundAppearances}</td>
                                        </tr>
                                    ))}
                                    {playerData.length <= 0 && (
                                        <tr>
                                            <h2 className='text-center'>No players found that match the specified criteria.</h2>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </React.Fragment>);
        } else {
            tableArray = (<span>Loading...</span>);
        }
        return (tableArray);
    };

    const handleModeChange = (e) => {
        setGameType(e.target.value);
    };

    function renderSeasonSelect() {
        return (
            <select value={season} onChange={(e) => setSeason(parseInt(e.target.value))}>
                <option key={null} value={null}>
                    All Seasons
                </option>
                {seasonData.length > 0 && seasonData.map(season => (
                    <option key={season.id} value={season.id}>
                        {season.seasonName}
                    </option>
                ))}
            </select>
        );
    };

    const renderModeSelect = () => {
        return (
            <select value={gameType} onChange={(e) => handleModeChange(e)}>
                {Object.keys(GameType).map(key => (
                    <option key={key} value={key}>
                        {GameType[key]}
                    </option>
                ))}
            </select>
        );
    };

    const renderDropdownBar = () => {
        return (
            <Row>
                <Col>
                    <div className='clearfix'>
                        {renderSeasonSelect()} {renderModeSelect()}
                    </div>
                    <br />
                </Col>
            </Row>
        );
    };

    return (
        <React.Fragment>
            <h1 id="tabelLabel">Players</h1>
            {renderDropdownBar()}
            {renderDemosTable()}
        </React.Fragment>
    );
};

export default Players;